import { useRef } from 'react'

import { Empty } from '../Common/Empty'
import { getPostPreviewEntries } from '../Common/getPostPreviewEntries'
import { BlueskyPost } from './components/BlueskyPost/BlueskyPost'
import { useScrollToThreadedPost } from '../Common/hooks/useScrollToThreadedPost'
import { PostPreviewCard } from '../Common/styles'
import type {
  ProfilePreview,
  BaseDraftWithThread,
  ThreadsContent,
} from '../types'

import type { JSX } from 'react'

const getPosts = (draft: BaseDraftWithThread): ThreadsContent[] => {
  if (draft.thread) {
    const { activeThreadId } = draft

    return draft.thread.map((threadedDraft, i) =>
      activeThreadId === i ? draft : threadedDraft,
    )
  } else {
    return [draft]
  }
}

export const BlueskyPreview = ({
  draft,
  profile,
}: {
  draft: BaseDraftWithThread
  profile: ProfilePreview
}): JSX.Element => {
  const { isEmpty, hasThread, activeThreadId, service } = draft
  const singlePostIdentityRef = useRef<object>({})

  const posts = getPosts(draft)
  const postEntries = getPostPreviewEntries(
    posts,
    (post) => post,
    (_post, index) => draft.thread?.[index] ?? singlePostIdentityRef.current,
  )

  useScrollToThreadedPost(!service.isOmni ? activeThreadId : undefined)

  if (isEmpty && !hasThread) {
    return <Empty />
  }

  return (
    <PostPreviewCard data-testid="bluesky-preview">
      {postEntries.map(({ key, post }, index) => (
        <BlueskyPost key={key} content={post} profile={profile} index={index} />
      ))}
    </PostPreviewCard>
  )
}
